import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIMediaLeft(props) {
  const {
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    className: classNames("private-media__item private-media__item--left", className)
  }));
}
UIMediaLeft.displayName = 'UIMediaLeft';
UIMediaLeft.propTypes = {
  children: PropTypes.node
};